import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"
import _imports_0 from '@/img/trash.svg'


const _hoisted_1 = { class: "chatRoomLayout" }
const _hoisted_2 = {
  key: 0,
  class: "chatStatusContainer"
}
const _hoisted_3 = { class: "d-flex align-items-center" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode()
const _hoisted_5 = { class: "chatMessagesCounter" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" | ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode()
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col-sm-2 left" }
const _hoisted_10 = {
  key: 0,
  class: "text-center"
}
const _hoisted_11 = { class: "py-4" }
const _hoisted_12 = ["src"]
const _hoisted_13 = { class: "form-group" }
const _hoisted_14 = ["readonly"]
const _hoisted_15 = { class: "form-group" }
const _hoisted_16 = ["readonly"]
const _hoisted_17 = { class: "form-group" }
const _hoisted_18 = ["readonly"]
const _hoisted_19 = { class: "mt-3" }
const _hoisted_20 = { class: "mt-3" }
const _hoisted_21 = { class: "mt-3" }
const _hoisted_22 = /*#__PURE__*/_createTextVNode()
const _hoisted_23 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_24 = {
  key: 0,
  class: "col-sm-10 right"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_toggler = _resolveComponent("toggler")!
  const _component_chat = _resolveComponent("chat")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.selectedChatRoom)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_localized_text, {
              localizedKey: "Stato stanza",
              text: "Stato stanza"
            }),
            _hoisted_4,
            _createVNode(_component_toggler, {
              class: "ml-2",
              modelValue: _ctx.selectedChatRoom.disabled,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedChatRoom.disabled) = $event)),
              onInput: _ctx.disableChatRoom,
              inverse: true
            }, null, 8, ["modelValue", "onInput"])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_localized_text, {
              localizedKey: "Messaggi:",
              text: "Messaggi:"
            }),
            _createElementVNode("span", null, _toDisplayString(_ctx.selectedChatRoom.messagesCount), 1),
            _hoisted_6,
            _createVNode(_component_localized_text, {
              localizedKey: "Caricati:",
              text: "Caricati:"
            }),
            _hoisted_7,
            _createElementVNode("span", null, _toDisplayString(_ctx.loadedMessages), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        (_ctx.selectedChatRoom)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                (_ctx.selectedChatRoom.imgUrl)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: _ctx.selectedChatRoom.imgUrl,
                      width: "100%"
                    }, null, 8, _hoisted_12))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("label", null, [
                  _createVNode(_component_localized_text, {
                    localizedKey: "Titolo",
                    text: "Titolo"
                  })
                ]),
                _withDirectives(_createElementVNode("textarea", {
                  readonly: !_ctx.editDetails,
                  class: "form-control",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedChatRoom.title) = $event))
                }, null, 8, _hoisted_14), [
                  [_vModelText, _ctx.selectedChatRoom.title]
                ])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("label", null, [
                  _createVNode(_component_localized_text, {
                    localizedKey: "Descrizione",
                    text: "Descrizione"
                  })
                ]),
                _withDirectives(_createElementVNode("textarea", {
                  readonly: !_ctx.editDetails,
                  class: "form-control",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedChatRoom.description) = $event))
                }, null, 8, _hoisted_16), [
                  [_vModelText, _ctx.selectedChatRoom.description]
                ])
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("label", null, [
                  _createVNode(_component_localized_text, {
                    localizedKey: "Url immagine",
                    text: "Url immagine"
                  })
                ]),
                _withDirectives(_createElementVNode("textarea", {
                  readonly: !_ctx.editDetails,
                  class: "form-control",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectedChatRoom.imgUrl) = $event))
                }, null, 8, _hoisted_18), [
                  [_vModelText, _ctx.selectedChatRoom.imgUrl]
                ])
              ]),
              _createElementVNode("div", _hoisted_19, [
                (!_ctx.editDetails)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      type: "button",
                      class: "btn btn-primary",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.editDetails = !_ctx.editDetails))
                    }, [
                      _createVNode(_component_localized_text, {
                        localizedKey: "Modifica dati",
                        text: "Modifica dati"
                      })
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_20, [
                (_ctx.editDetails)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      type: "button",
                      class: "btn btn-primary",
                      onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.save && _ctx.save(...args)))
                    }, [
                      _createVNode(_component_localized_text, {
                        localizedKey: "Salva",
                        text: "Salva"
                      })
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-shadow",
                  onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.removeChatRoom && _ctx.removeChatRoom(...args)))
                }, [
                  _createVNode(_component_localized_text, {
                    localizedKey: "Elimina stanza",
                    text: "Elimina stanza"
                  }),
                  _hoisted_22,
                  _hoisted_23
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      (_ctx.selectedChatRoom)
        ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
            _createVNode(_component_chat, {
              chatIdentifier: _ctx.selectedChatRoom.identifier,
              onMessage: _ctx.onMessage,
              onMessageremove: _ctx.onMessageRemove,
              onLoadedmessages: _ctx.onLoadedMessages
            }, null, 8, ["chatIdentifier", "onMessage", "onMessageremove", "onLoadedmessages"])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}